module.exports = __webpack_public_path__ + "img/border-bottom.adaf80fd.svg";